(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react-emotion', '../fonts/fonts', '../colors'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react-emotion'), require('../fonts/fonts'), require('../colors'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.reactEmotion, global.fonts, global.colors);
    global.index = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _reactEmotion, _fonts, _colors) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.bold = exports.link = exports.muted = exports.paragraph = exports.note = exports.label = exports.headline2 = exports.headline1 = exports.display3 = exports.display2 = exports.display1 = undefined;

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _colors2 = _interopRequireDefault(_colors);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n  body, html {\n    color: ', ';\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    font-family: "Proxima Nova", Helvetica, sans-serif;\n    color: ', ';\n  }\n'], ['\n  body, html {\n    color: ', ';\n    font-weight: normal;\n    font-style: normal;\n    font-stretch: normal;\n    letter-spacing: normal;\n    font-family: "Proxima Nova", Helvetica, sans-serif;\n    color: ', ';\n  }\n']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-size: 3.75rem;\n  line-height: 1.2;\n  font-weight: 600;\n  font-family: ', ';\n  color: ', ';\n'], ['\n  font-size: 3.75rem;\n  line-height: 1.2;\n  font-weight: 600;\n  font-family: ', ';\n  color: ', ';\n']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-size: 3.75rem;\n  line-height: 1.2;\n  font-weight: 100;\n  font-family: ', ';\n  color: ', ';\n'], ['\n  font-size: 3.75rem;\n  line-height: 1.2;\n  font-weight: 100;\n  font-family: ', ';\n  color: ', ';\n']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-family: ', ';\n  color: ', ';\n  font-size: 2.5rem;\n  line-height: 1.2;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  font-size: 2.5rem;\n  line-height: 1.2;\n']),
      _templateObject5 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-size: 2.125rem;\n  line-height: 1.18;\n  font-weight: 600;\n  font-family: ', ';\n  color: ', ';\n'], ['\n  font-size: 2.125rem;\n  line-height: 1.18;\n  font-weight: 600;\n  font-family: ', ';\n  color: ', ';\n']),
      _templateObject6 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-size: 1.5635rem;\n  font-weight: 400;\n  line-height: 1.28;\n  color: ', ';\n'], ['\n  font-size: 1.5635rem;\n  font-weight: 400;\n  line-height: 1.28;\n  color: ', ';\n']),
      _templateObject7 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-family: ', ';\n  color: ', ';\n  font-size: 1.1875rem;\n  line-height: 1.26;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  font-size: 1.1875rem;\n  line-height: 1.26;\n']),
      _templateObject8 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-family: ', ';\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.5;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  font-size: 1rem;\n  line-height: 1.5;\n']),
      _templateObject9 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-family: ', ';\n  color: ', ';\n  font-size: 0.8125rem;\n  line-height: 1.23;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  font-size: 0.8125rem;\n  line-height: 1.23;\n']),
      _templateObject10 = (0, _taggedTemplateLiteralLoose3.default)(['\n  color: ', ';\n'], ['\n  color: ', ';\n']),
      _templateObject11 = (0, _taggedTemplateLiteralLoose3.default)(['\n  color: ', ' !important;\n'], ['\n  color: ', ' !important;\n']),
      _templateObject12 = (0, _taggedTemplateLiteralLoose3.default)(['\n  font-weight: bold;\n'], ['\n  font-weight: bold;\n']);

  (0, _reactEmotion.injectGlobal)(_templateObject, _colors2.default.prussian, _colors2.default.prussian);

  // Product broke convention here.
  // If you use this class, please check with product
  // to see if we will be creating a headline1 muted or bold.
  var display1 = (0, _reactEmotion.css)(_templateObject2, _fonts.ProximaNovaT, _colors2.default.prussian);
  // Product broke convention here.
  // If you use this class, please check with product
  // to see if we will be creating a headline1 muted or bold.
  var display2 = (0, _reactEmotion.css)(_templateObject3, _fonts.ProximaNovaThin, _colors2.default.prussian);
  var display3 = (0, _reactEmotion.css)(_templateObject4, _fonts.ProximaNova, _colors2.default.prussian);
  // Product broke convention here.
  // If you use this class, please check with product
  // to see if we will be creating a headline1 muted or bold.
  var headline1 = (0, _reactEmotion.css)(_templateObject5, _fonts.ProximaNovaT, _colors2.default.prussian);
  var headline2 = (0, _reactEmotion.css)(_templateObject6, _colors2.default.prussian);
  var label = (0, _reactEmotion.css)(_templateObject7, _fonts.ProximaNova, _colors2.default.prussian);
  var paragraph = (0, _reactEmotion.css)(_templateObject8, _fonts.ProximaNova, _colors2.default.prussian);
  var note = (0, _reactEmotion.css)(_templateObject9, _fonts.ProximaNova, _colors2.default.prussian);
  var muted = (0, _reactEmotion.css)(_templateObject10, _colors2.default.slate);
  var link = (0, _reactEmotion.css)(_templateObject11, _colors2.default.jungle);

  var bold = (0, _reactEmotion.css)(_templateObject12);

  exports.display1 = display1;
  exports.display2 = display2;
  exports.display3 = display3;
  exports.headline1 = headline1;
  exports.headline2 = headline2;
  exports.label = label;
  exports.note = note;
  exports.paragraph = paragraph;
  exports.muted = muted;
  exports.link = link;
  exports.bold = bold;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/typography/index.js
// module id = 490
// module chunks = 1